module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/fbjs/~/core-js/library/modules/$.redefine.js
// module id = 486
// module chunks = 0